const isDevelopment = process.env.NODE_ENV === 'development';

const BASE_URL = isDevelopment ? 'http://0.0.0.0:8007' : '';

const config = {
  // API endpoints
  publicBaseUrl: `${BASE_URL}/public`,
  isDevelopment,
  // Anzeige-Label der laufenden Saison; muss zu CLUBEE_CURRENT_SEASON im Backend passen.
  seasonLabel: '2026-27',
};

export default Object.freeze(config);